import React from 'react'

export const PuzzleIcon: React.FC = () => (
  <svg width="48" height="48">
    <defs>
      <filter id="puzzle_icon_a">
        <feColorMatrix
          in="SourceGraphic"
          values="0 0 0 0 1.000000 0 0 0 0 1.000000 0 0 0 0 1.000000 0 0 0 1.000000 0"
        />
      </filter>
    </defs>
    <g fill="none" fillRule="evenodd">
      <rect width="48" height="48" fill="#E68027" rx="16" />
      <g filter="url(#puzzle_icon_a)" transform="translate(12 12)">
        <path
          fill="#9A8B88"
          d="M22.6066 9.8787c1.1716 1.1716 1.1716 3.071 0 4.2426l-8.4853 8.4853c-1.1716 1.1716-3.071 1.1716-4.2426 0l-8.4853-8.4853c-1.1716-1.1716-1.1716-3.071 0-4.2426l8.4853-8.4853c1.1716-1.1716 3.071-1.1716 4.2426 0l8.4853 8.4853zm-12.728 4.2426c-1.1715-1.1716-3.071-1.1716-4.2426 0-1.1715 1.1716-1.1715 3.071 0 4.2427 1.1716 1.1715 3.0711 1.1715 4.2427 0 1.1716-1.1716 1.1716-3.0711 0-4.2427zm12.728 4.2427c1.1716 1.1715 1.1716 3.071 0 4.2426-1.1716 1.1716-3.071 1.1716-4.2426 0-1.1716-1.1716-1.1716-3.071 0-4.2426 1.1715-1.1716 3.071-1.1716 4.2426 0zM5.636 1.3934c1.1716 1.1716 1.1716 3.071 0 4.2426-1.1715 1.1716-3.071 1.1716-4.2426 0-1.1716-1.1715-1.1716-3.071 0-4.2426 1.1716-1.1716 3.071-1.1716 4.2426 0zM18.364 5.636c-1.1716-1.1715-3.0711-1.1715-4.2427 0-1.1716 1.1716-1.1716 3.0711 0 4.2427 1.1716 1.1716 3.071 1.1716 4.2427 0 1.1715-1.1716 1.1715-3.071 0-4.2427z"
        />
      </g>
    </g>
  </svg>
)
